import { Injectable } from '@angular/core';
import {
    BaseHttpService,
    Create, Delete,
    GetById, Update,
    UriBuilderParams
} from '@app/core/services/base/base-http.service';
import { HttpServiceBundle } from '@app/core/services/base/http-service-bundle.service';
import { Observable } from 'rxjs';
import { DrQueryParams } from '@app/core/services/base/base-service-with-bundle.service';
import { map } from 'rxjs/operators';
import { BackendUriUnits } from '@app/core/services/base/backend-uri-units';
import { AddressBookEntry, AddressBookEntryList } from '@app/shared/models/address-book-entry';
import {
    CaseCreationDialogComponent
} from "@app/modules/case/components/case-creation-dialog/case-creation-dialog.component";
import {
    AddressBookSearchDialogComponent
} from "@app/shared/dialogs/address-book-search-dialog/address-book-search-dialog.component";

export class AddressBookEntryUriBuilderParams extends UriBuilderParams<AddressBookEntry> {

    constructor(contact?: AddressBookEntry | string) {
        super(contact);
    }

    public buildUri(): string {
        const uriPart = `${BackendUriUnits.CLIENTS}/${BackendUriUnits.ADDRESS_BOOK}/${BackendUriUnits.CONTACTS}`;
        return this.simpleUriBuild(uriPart);
    }
}

@Injectable({ providedIn: 'root' })
export class AddressBookEntryService extends BaseHttpService<AddressBookEntry, AddressBookEntryUriBuilderParams>
                                     implements GetById<AddressBookEntry, AddressBookEntryUriBuilderParams>,
                                                Create<AddressBookEntry, AddressBookEntryUriBuilderParams>,
                                                Update<AddressBookEntry, AddressBookEntryUriBuilderParams>,
                                                Delete<AddressBookEntry, AddressBookEntryUriBuilderParams> {

    constructor(httpServiceBundle: HttpServiceBundle) {
        super(AddressBookEntry, httpServiceBundle, true);
    }

    // BASE METHODS ****************************************************************************************

    public getById(uriParams: AddressBookEntryUriBuilderParams): Observable<AddressBookEntry> {
        return this.getBaseById(uriParams);
    }

    public create(uriParams: AddressBookEntryUriBuilderParams, contactToCreate: AddressBookEntry): Observable<AddressBookEntry> {
        return this.createBase(uriParams, contactToCreate);
    }

    public update(uriParams: AddressBookEntryUriBuilderParams, contactToUpdate: AddressBookEntry, params?: DrQueryParams): Observable<AddressBookEntry> {
        return this.updateBase(uriParams, contactToUpdate, params);
    }

    public delete(uriParams: AddressBookEntryUriBuilderParams): Observable<boolean> {
        return this.deleteBase(uriParams);
    }


    // EXTRA METHODS ****************************************************************************************

    public query(uriParams: AddressBookEntryUriBuilderParams, params?: DrQueryParams): Observable<AddressBookEntryList> {
        const uri = this.constructUri(uriParams, params);
        return this.http.get<AddressBookEntryList>(uri, params && params.queryParams ? { params: params.queryParams } : null)
                        .pipe(map((result: any)  => new AddressBookEntryList(AddressBookEntry, result.data)));
    }

    public openSearchAddressBookEntryModal(): Observable<AddressBookEntry> {
        const dialogRef = this.dialog.open(AddressBookSearchDialogComponent, {
            width: '70%',
            data: {}
        });
        return dialogRef.afterClosed();
    }


}
